function toCamelCase(str: string): string {
	return str.replace(/^[A-Z]+(?=[A-Z][a-z]|[0-9]|$)|^[A-Z]/, m => m.toLowerCase());
}

function recurse<T>(value: T): T {
	if (Array.isArray(value)) {
		return value.map(recurse) as unknown as T;
	}

	if (value !== null && typeof value === 'object' && value.constructor === Object) {
		const out: Record<string, unknown> = {};
		for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
			out[toCamelCase(key)] = recurse(val);
		}
		return out as T;
	}

	return value;
}

export function deepCamelCase<T>(value: T): T {
	return recurse(value);
}
